import { useMemo } from "react";
import type { ChatMessage } from "../lib/types";
import { renderMarkdown } from "../lib/markdown";

interface Props {
  message: ChatMessage;
  onSuggestion?: (text: string) => void;
}

export function ChatBubble({ message, onSuggestion }: Props) {
  const html = useMemo(() => renderMarkdown(message.text), [message.text]);

  const cls = `cw-bubble cw-bubble--${message.role}` + (message.pending ? " cw-bubble--pending" : "");

  return (
    <div className={cls} data-message-id={message.message_id}>
      <div className="cw-avatar" aria-hidden="true">
        {message.role === "assistant" ? "v0" : message.role === "system" ? "!" : "·"}
      </div>
      <div className="cw-bubble__body">
        <div className="cw-bubble__text" dangerouslySetInnerHTML={{ __html: html }} />
        {message.suggestions && message.suggestions.length > 0 && (
          <div className="cw-suggestions">
            {message.suggestions.map((s) => (
              <button
                key={s}
                type="button"
                className="ds-button ds-button--ghost cw-suggestion"
                onClick={() => onSuggestion?.(s)}
              >
                {s}
              </button>
            ))}
          </div>
        )}
        {message.error_code && (
          <span className="cw-bubble__error">{message.error_code}</span>
        )}
      </div>
    </div>
  );
}
